import { PropsWithChildren, useEffect } from 'react';
import { useEventViewContent } from 'src/analytics/useEventViewContent';
import { TrackedPageProvider, TrackedPageProviderProps } from 'src/context/trackedPage';

export const Tracker = ({ children }: PropsWithChildren) => {
  const eventViewContent = useEventViewContent();

  useEffect(() => {
    window.dataLayer.push(eventViewContent);
  }, [eventViewContent]);

  return children;
};

export const TrackedPage = ({ children, ...rest }: TrackedPageProviderProps) => {
  return (
    <TrackedPageProvider {...rest}>
      <Tracker>{children}</Tracker>
    </TrackedPageProvider>
  );
};
